import { tourService } from '../_services';

export const tours = {
  namespaced: true,
  state: {
    all: {},
    singleDetail: {},
    allAtOnce: {},
    today: {},
    stats: {},
    completeTour: {
      items: {
        tour: {
          contracts: [
            {
              absa: '',
              contractNumber: '',
              customer: {
                absa: '',
                city: '',
                created_at: '',
                email: '',
                id: 0,
                latitude: 0,
                longitude: 0,
                mobile: '',
                name: '',
                name2: '',
                phone: '',
                position: {
                  lat: 0,
                  lng: 0
                },
                street: '',
                updated_at: '',
                zip: ''
              },
              deleteReason: null,
              deleted: null,
              deletedAt: null,
              done: false,
              doneAt: '',
              id: 0,
              loadno: '',
              sorting: 0
            }
          ],
          created_at: '',
          device: '',
          driver: {
            firstname: '',
            id: 0,
            lastname: '',
            perid: 0
          },
          driverID: 0,
          id: 0,
          kfz: '',
          kmdriven: 0,
          loadno: '',
          location: {
            firstname: '',
            id: 0,
            kfz: '',
            lastname: '',
            latitude: 0,
            loadno: '',
            longitude: 0,
            tourid: 0
          },
          tourfinished: false,
          tourname: ''
        }
      }
    }
  },
  getters: {
    all: state => {
      return state.all;
    },
    singleDetail: state => {
      return state.singleDetail;
    },
    allAtOnce: state => {
      return state.allAtOnce;
    },
    today: state => {
      return state.today;
    },
    stats: state => {
      return state.stats;
    },
    completeTour: state => {
      return state.completeTour.items.tour;
    }
  },
  actions: {
    getAll({ commit }, { perpage, page, sortby, descending }) {
      commit('getAllRequest');

      tourService
        .getAll(perpage, page, sortby, descending)
        .then(
          tours => commit('getAllSuccess', tours),
          error => commit('getAllFailure', error)
        );
    },
    getAllAtOnce({ commit }) {
      commit('getAllAtOnceRequest');
      console.log('get All At Once');
      tourService
        .getAllAtOnce()
        .then(
          tours => commit('getAllAtOnceSuccess', tours),
          error => commit('getAllFailure', error)
        );
    },
    getToday({ commit }) {
      commit('getTodayRequest');
      tourService
        .getToday()
        .then(
          tours => commit('getTodaySuccess', tours),
          error => commit('getAllFailure', error)
        );
    },
    getStats({ commit }) {
      commit('getTourStatsRequest');
      tourService
        .getStats()
        .then(
          stats => commit('getTourStatsSuccess', stats),
          error => commit('getAllFailure', error)
        );
    },
    getSingleDetail({ commit }, { loadno }) {
      commit('getSingleDetailRequest');

      tourService
        .getAll(loadno)
        .then(
          tour => commit('getSingleDetailSuccess', tour),
          error => commit('getSingleDetailFailure', error)
        );
    },
    getCompleteTour({ commit }, { loadno }) {
      tourService
        .getCompleteTour(loadno)
        .then(
          tour => commit('getCompleteTourSuccess', tour),
          error => commit('getCompleteTourFailure', error)
        );
    }
  },
  mutations: {
    getAllRequest(state) {
      state.all = { loading: true };
    },
    getAllSuccess(state, tours) {
      state.all = { items: tours };
    },
    getAllFailure(state, error) {
      state.all = { error };
    },
    getSingleDetail(state, tour) {
      state.singleDetail = { items: tour };
    },
    getAllAtOnceSuccess(state, tours) {
      state.allAtOnce = { items: tours };
    },
    getTodaySuccess(state, tours) {
      state.today = { items: tours };
    },
    getTourStatsSuccess(state, stats) {
      state.stats = { items: stats };
    },
    getCompleteTourSuccess(state, tour) {
      state.completeTour = { items: tour };
    },
    getCompleteTourFailure(state, error) {
      state.completeTour = { error };
    }
  }
};
